export enum Behaviour {
  dropdown = 'dropdown'
}
